import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SelvedgeWordingReferenceService extends BaseReferenceService {
  constructor() {
    super('SelvedgeWordingReference');
  }
}
